import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../services/api';
import './ReviewList.css';
import FeedCard from './FeedCard';
import { Link } from 'react-router-dom';

// TODO: FIX CASCADING DELETES WHEN THERE ARE NESTED COMMENTS, ETC
function ReviewList({ user, onLogin, toast, onRegularLogin }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterCount, setFilterCount] = useState(0);
  const location = useLocation();
  const loadReviews = async () => {
    try {
      const searchParams = new URLSearchParams(location.search);
      const surgeryParam = searchParams.get('surgery');
      const userParam = searchParams.get('user');
      const loginParam = searchParams.get('login')
      if (loginParam && !user) {
        onRegularLogin()
      }
      let filterCount = 0
      if (userParam) {
        filterCount += 1
      }
      if (surgeryParam) {
        filterCount += 1
      }
      setFilterCount(filterCount)

      const [reviewsData] = await Promise.all([
        api.getReviews(surgeryParam, userParam),
        api.getStates()
      ]);
      setReviews(reviewsData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadReviews();
  }, [location.search]);

  const updateReview = (i) => (review) => {
    reviews[i] = { ...review }
    setReviews([...reviews])
  }

  if (loading) {
    return <div className="loading">Loading reviews...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="review-list-container" style={{ paddingTop: '0px' }}>
      {reviews.length === 0 ? (
        <div className="empty-state">
          <p>No results found for your current filters.</p>
        </div>
      ) : (
        <div className="reviews">
          {reviews.map((review, index) => (
            <FeedCard
              key={review.id}
              onLogin={onLogin}
              review={review}
              updateReview={updateReview(index)}
              user={user}
              toast={toast}
              loadReviews={loadReviews}
            />
          ))}
        </div>
      )}
      {
        filterCount > 0 && (
          <Link to="/surgeries" style={{ width: '100%', marginTop: '1rem' }} className="hide-link-styles">
            <button className="filter-toggle" style={{ width: '100%', marginTop: '1rem' }}>
              <div style={{ margin: 'auto' }}>Clear Filters ({filterCount})</div>
            </button>
          </Link>
        )
      }
    </div>
  );
}

export default ReviewList; 